var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c("FormsAutocomplete", {
        attrs: {
          item: _setup.collection,
          label: _vm.label,
          disabled: _vm.disabled,
          "error-messages": _vm.errorMessages,
          dense: _vm.dense,
        },
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }